<template>
  <div class="jm-mb-3">
    <label
      v-if="label"
      class="jm-d-inline-block jm-mb-2"
      data-test="radio-group-label"
      >{{ label }}</label
    >
    <BaseRadio
      v-for="option in options"
      :key="`${option.value}-${name}`"
      :id="`${option.value}-${name}`"
      :label="option.label"
      :value="option.value"
      :modelValue="modelValue"
      :name="name"
      @update:modelValue="$emit('update:modelValue', $event)"
      data-test="radio-button"
    />
  </div>
</template>

<script>
import BaseRadio from '@/components/molecules/form/BaseRadio.vue'
export default {
  name: 'BaseRadioGroup',
  components: { BaseRadio },
  props: {
    label: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    modelValue: {
      type: [String, Boolean],
      required: true
    }
  }
}
</script>
